import EcoImg from 'eco-design/base/eco-img';
import EcoButton from 'eco-design/base/eco-button';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import getLocal from '@/app/utils/i18n';

const LightestProduct = () => {
    const { t } = useLang('Delta3AirStation.LightestProduct');
    const { locale } = getLocal();

    const handlePushGtm = (product: string, url: string) => {
        saveCookieForShopify(url, locale);
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: product,
            position: t('title'),
        });
    };
    return (
        <section className={`${styles.LightestProduct} GtmModuleData-section`} data-section-id="LightestProduct">
            <div className="content">
                {/* <div className="title">{t('title')}</div> */}
                <div className="light-prod-detail-pc">
                    <div className="left-box">
                        <div className="title">{t('title')}</div>
                        <div className="prod-desc-content">
                            <div className="prod-desc-box">
                                <div className="item-prod-desc-1">
                                    <span className="value">{t('desc_value_1')}</span>
                                    <div className="line"></div>
                                    <span className="value">{t('desc_value_2')}</span>
                                </div>
                                {/* <div className="line"></div> */}
                                <div className="item-prod-desc-2">
                                    <span className="label">{t('desc_label_1')}</span>
                                    <span className="label">{t('desc_label_2')}</span>
                                </div>
                            </div>
                            {/* <div className="detail-btn">
                                <EcoButton
                                    className="btn"
                                    lType="outlined"
                                    lHref="https://jp.ecoflow.com/pages/products-delta-3-1000-air-portable-power-station"
                                    onClick={() => handlePushGtm(t('title'), 'https://jp.ecoflow.com/pages/products-delta-3-1000-air-portable-power-station')}
                                >
                                    {t('detailBtn')}
                                </EcoButton>
                            </div> */}
                            <div className="tips">{t('tips')}</div>
                        </div>
                    </div>

                    <div className="right">
                        <EcoImg
                            className="product-img"
                            alt={t('title')}
                            pc="https://websiteoss.ecoflow.com/upload/image/1762237554250/light-pc.png"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762237554250/light-pc.png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762237554381/light-m.png"
                            isOpenLazy
                        ></EcoImg>
                    </div>
                </div>
                <div className="light-prod-detail-h5">
                    <div className="title">{t('title')}</div>
                    <div className="detail-wrap">
                        <EcoImg
                            className="product-img"
                            alt={t('title')}
                            pc="https://websiteoss.ecoflow.com/upload/image/1762237554250/light-pc.png"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762237554250/light-pc.png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762237554381/light-m.png"
                            isOpenLazy
                        ></EcoImg>
                        <div className="prod-desc-content">
                            <div className="prod-desc-box">
                                <div className="item-prod-desc-1">
                                    <span className="value">{t('desc_value_1')}</span>
                                    <div className="line"></div>
                                    <span className="value">{t('desc_value_2')}</span>
                                </div>
                                {/* <div className="line"></div> */}
                                <div className="item-prod-desc-2">
                                    <span className="label">{t('desc_label_1')}</span>
                                    {/* <span className="label">{t('desc_label_2')}</span> */}
                                </div>
                            </div>
                            <div className="tips">{t('tips')}</div>
                        </div>
                    </div>
                    {/* <div className="detail-btn">
                        <EcoButton className="btn" lType="outlined" lHref="https://jp.ecoflow.com/pages/products-delta-3-1000-air-portable-power-station">
                            {t('detailBtn')}
                        </EcoButton>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default LightestProduct;
